import React from "react"
import { Icon as ChakraIcon } from "@chakra-ui/react"

const GripIcon = () => (
  <ChakraIcon viewBox="0 0 24 24" boxSize={3} color="gray.400">
    <circle cx="9" cy="7" r="1.5" fill="currentColor" />
    <circle cx="15" cy="7" r="1.5" fill="currentColor" />
    <circle cx="9" cy="12" r="1.5" fill="currentColor" />
    <circle cx="15" cy="12" r="1.5" fill="currentColor" />
    <circle cx="9" cy="17" r="1.5" fill="currentColor" />
    <circle cx="15" cy="17" r="1.5" fill="currentColor" />
  </ChakraIcon>
)

export default GripIcon
